__turbopack_context__.v({
  "active": "styles-module-scss-module__aJIJya__active",
  "label": "styles-module-scss-module__aJIJya__label",
  "labelMobile": "styles-module-scss-module__aJIJya__labelMobile",
  "labels": "styles-module-scss-module__aJIJya__labels",
  "reversedRoot": "styles-module-scss-module__aJIJya__reversedRoot",
  "reversedText": "styles-module-scss-module__aJIJya__reversedText",
  "root": "styles-module-scss-module__aJIJya__root",
  "switcher": "styles-module-scss-module__aJIJya__switcher",
  "switcherOff": "styles-module-scss-module__aJIJya__switcherOff",
  "switcherOn": "styles-module-scss-module__aJIJya__switcherOn",
  "switcherWrap": "styles-module-scss-module__aJIJya__switcherWrap",
  "thumb": "styles-module-scss-module__aJIJya__thumb",
  "track": "styles-module-scss-module__aJIJya__track",
});
